/**
 * FBTR quick add: a "Quick add" button on product cards opens a pop-up with the product's roll picker.
 * The pop-up content is the product's `fbtr-quick` view (templates/product.fbtr-quick.liquid). The picker inside works
 * like the one on the product page: its Add to cart button is the theme's own, which adds the rolls and opens the
 * theme's cart popup. When the cart is redrawn we close this pop-up.
 */
(() => {
  let modal;
  let lastTrigger;

  const build = () => {
    modal = document.createElement('div');
    modal.className = 'fbtr-qv';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="fbtr-qv__backdrop" data-close></div>' +
      '<div class="fbtr-qv__dialog" role="dialog" aria-modal="true" aria-label="Quick add">' +
      '<button type="button" class="fbtr-qv__close" data-close aria-label="Close">&times;</button>' +
      '<div class="fbtr-qv__body"></div></div>';
    document.body.append(modal);
    modal.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('[data-close]')) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
    // The theme redraws #cart-info after every add: that is our cue that the rolls are in the cart
    const cartInfo = document.getElementById('cart-info');
    if (cartInfo) new MutationObserver(() => !modal.hidden && close()).observe(cartInfo, { childList: true });
  };

  const close = () => {
    modal.hidden = true;
    document.body.classList.remove('fbtr-qv-open');
    modal.querySelector('.fbtr-qv__body').replaceChildren();
    lastTrigger?.focus();
  };

  const open = async (url, trigger) => {
    // only our own product pages
    let target;
    try { target = new URL(url, location.origin); } catch { return; }
    if (target.origin !== location.origin) return;
    url = target.pathname;
    if (!modal) build();
    lastTrigger = trigger;
    const body = modal.querySelector('.fbtr-qv__body');
    body.innerHTML = '<p class="fbtr-qv__loading">Loading…</p>';
    modal.hidden = false;
    document.body.classList.add('fbtr-qv-open');
    try {
      const response = await fetch(`${url}${url.includes('?') ? '&' : '?'}view=fbtr-quick`);
      if (!response.ok) throw new Error(String(response.status));
      body.innerHTML = await response.text();
      modal.querySelector('.fbtr-qv__close').focus();
    } catch {
      const note = document.createElement('p');
      note.className = 'fbtr-qv__loading';
      note.append('Sorry, that did not load. ');
      const link = document.createElement('a');
      link.href = url;
      link.textContent = 'Open the product page';
      note.append(link);
      body.replaceChildren(note);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-fbtr-qa]') : null;
    if (!(button instanceof HTMLElement)) return;
    event.preventDefault();
    event.stopPropagation();
    open(button.dataset.fbtrQa || '', button);
  });
})();
